import { render, staticRenderFns } from "./CommonPlatformDynamics.vue?vue&type=template&id=eb4c03ba&scoped=true"
import script from "./CommonPlatformDynamics.vue?vue&type=script&lang=js"
export * from "./CommonPlatformDynamics.vue?vue&type=script&lang=js"
import style0 from "./CommonPlatformDynamics.vue?vue&type=style&index=0&id=eb4c03ba&prod&lang=less"
import style1 from "./CommonPlatformDynamics.vue?vue&type=style&index=1&id=eb4c03ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4c03ba",
  null
  
)

export default component.exports